import { RouteRecordRaw } from 'vue-router'

import { CS_AREA_ROUTE_NAMES } from '@/modules/continuousService/constants/CSRouteNames'

export const csAreaRoute: RouteRecordRaw = {
  path: 'continuous-service',
  name: CS_AREA_ROUTE_NAMES.LIST,
  component: () => import('@/modules/continuousService/layouts/CSAreaLayout.vue'),
  props: route => {
    const csAreaId = route.params.csAreaId
    if (!csAreaId) return { csAreaId: undefined }
    return { csAreaId: isNaN(Number(csAreaId)) ? csAreaId : Number(csAreaId) }
  },
  children: [
    {
      path: ':csAreaId/edit',
      name: CS_AREA_ROUTE_NAMES.EDIT,
      component: () => import('@/modules/continuousService/pages/CSAreaEdit.vue'),
      props: route => {
        const csAreaId = route.params.csAreaId
        return { csAreaId: isNaN(Number(csAreaId)) ? csAreaId : Number(csAreaId) }
      },
    },
  ],
}
